export function setPreviewUrlOptions(preview, width, height) {
    return `${preview}?w=${width}&h=${height ?? width}&m=fill`;
}
